import * as lookups from 'modules/api/lookups';
import { cancelFunctions } from 'utils/cancelFunctions';
import { CodeNameModel } from 'components/common/types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { FilterMultiCreativeIdProps } from './FilterMultiCreativeId.types';

const FilterMultiCreativeId: React.FC<FilterMultiCreativeIdProps> = ({ changeFilters, creativeIds, isDisabled }) => {
  const onLoadLookupData: AsyncSelectLoadDataHandler<CodeNameModel> = async (_, query) => {
    try {
      if (query.length < 2) {
        return [];
      }

      return await lookups.getCreativeIdsLookupSuggestions(cancelFunctions, query);
    } catch (error) {
      return [];
    }
  };

  const onSelect: SelectHandler<CodeNameModel> = (_, value: CodeNameModel[]): void => {
    changeFilters({
      creativeIds: value,
    });
  };

  return (
    <AsyncSelect
      dataTestId="creativeId-filter"
      name="creativeIds"
      loadData={onLoadLookupData}
      selectedValue={creativeIds}
      placeholder="Creative ID"
      onSelect={onSelect}
      multiple
      isDisabled={isDisabled}
    />
  );
};

export default FilterMultiCreativeId;
